class ProductPurchase extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.planInput = this.querySelector('[data-selling-plan]');
    this.form = this.closest('form');

    const priceData = this.querySelector('[data-purchase-prices]');
    try {
      this.prices = priceData ? JSON.parse(priceData.textContent) : {};
    } catch {
      this.prices = {};
    }

    this.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.matches('[data-purchase-option]')) return;
      this.#setPlan(input.value);
    });

    this.form?.addEventListener('submit', () => this.#silenceAppWidget(), true);

    const variantInput = this.form?.querySelector('input[name="id"]');
    if (variantInput) {
      const update = () => this.#updatePrices(variantInput.value);
      variantInput.addEventListener('change', update);
      this.variantObserver = new MutationObserver(update);
      this.variantObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }

    const scope = this.closest('.product-page') || this.parentElement;
    if (scope) {
      this.appObserver = new MutationObserver(() => this.#silenceAppWidget());
      this.appObserver.observe(scope, { childList: true, subtree: true });
    }

    this.#silenceAppWidget();
    const checked = this.querySelector('[data-purchase-option]:checked');
    this.#setPlan(checked instanceof HTMLInputElement ? checked.value : '');
  }

  #setPlan(value) {
    if (!this.planInput) return;
    this.planInput.value = value;
    this.planInput.disabled = value === '';
  }

  #updatePrices(variantId) {
    const plans = this.prices[String(variantId)];
    if (!plans) return;

    this.querySelectorAll('[data-plan-id]').forEach((option) => {
      const label = option.querySelector('[data-plan-label]');
      const text = plans[option.dataset.planId];
      if (label && text) label.textContent = text;
    });
  }

  #silenceAppWidget() {
    const root = this.closest('.product-page') || document;
    root.querySelectorAll('.appstle_sub_widget input[name="selling_plan"]').forEach((input) => {
      input.disabled = true;
      input.removeAttribute('name');
    });
  }
}

if (!customElements.get('product-purchase')) {
  customElements.define('product-purchase', ProductPurchase);
}
